export default "/_next/static/images/team-bg@2x-ed6ca8b42c2e2e5ade14f2584176e9e7.webp";